import * as types from './../actionTypes';

export function showModal() {
    return {type: types.SHOW_MODAL, status: true};
}

export function hideModal() {
    return {type: types.SHOW_MODAL, status: false};
}

export function showPreviewModal() {
    return {type: types.TRIGHER_PREVIEW_MODAL, status: true};
}

export function hidePreviewModal() {
    return {type: types.TRIGHER_PREVIEW_MODAL, status: false};
}

export function showSweetAlertModal(title,  text = '', showConfirm = true) {
    return {type: types.SHOW_SWEET_ALERT_MODAL, show: true, title, text, showConfirm};
}

export function hideSweetAlertModal() {
    return {type: types.HIDE_SWEET_ALERT_MODAL, show: false};
}

export function showTemplateAlertModal(title,  text = '') {
    return {type: types.SHOW_TEMPLATE_MODAL, show: true, title, text};
}

export function hideTemplateAlertModal() {
    return {type: types.HIDE_TEMPLATE_MODAL, show: false};
}

export function enableTemplateAlertModal() {
    return {type: types.ENABLE_TEMPLATE_MODAL, status: true};
}

export function disableTemplateAlertModal() {
    return {type: types.DISABLE_TEMPLATE_MODAL, status: false};
}

export function showResetFormModal() {
    return {type: types.SHOW_RESET_FORM_MODAL, status: true};
}

export function hideResetFormModal() {
    return {type: types.SHOW_RESET_FORM_MODAL, status: false};
}


// WEBPACK FOOTER //
// ./web/src/actions/common/modalActions.js